import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=19bc0d50&scoped=true&"
import script from "./NewsList.vue?vue&type=script&lang=js&"
export * from "./NewsList.vue?vue&type=script&lang=js&"
import style0 from "./NewsList.vue?vue&type=style&index=0&id=19bc0d50&lang=less&"
import style1 from "./NewsList.vue?vue&type=style&index=1&id=19bc0d50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc0d50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19bc0d50')) {
      api.createRecord('19bc0d50', component.options)
    } else {
      api.reload('19bc0d50', component.options)
    }
    module.hot.accept("./NewsList.vue?vue&type=template&id=19bc0d50&scoped=true&", function () {
      api.rerender('19bc0d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/NewsList.vue"
export default component.exports